import { Typography } from "@mui/material";
import { formatToCurrency } from "src/utils/genericFunctions";

const PrependCurrency = ({ value }: { value: any }) => {
  const getValue = () => {
    if (+value === 0 || value === null || value === "" || value === undefined) {
      return "-";
    }
    return formatToCurrency(value);
  };
  return (
    <Typography
      variant="subtitle2"
      color="grey.900"
      fontWeight={"normal"}
      sx={{ textTransform: "none", color: "grey.900" }}
    >
      {getValue()}
    </Typography>
  );
};

export default PrependCurrency;
